import { useContext } from 'react';
import LogContext from 'core/api/logContext';

function useLog() {
  return useContext(LogContext);
}

export default useLog;
